import useSWR, {SWRConfiguration} from 'swr';
import aiTutorAPI from '../axiosInstance';
import {Message} from './types';

export function fetchAiTutorMessagesRequest(
  session_id?: number,
  config?: SWRConfiguration,
) {
  return useSWR<Message[] | undefined>(
    ['/messages/', session_id],
    ([url, id]) => {
      if (!id) return [];

      return aiTutorAPI(`${url}${id}`, {method: 'get'})
        .then((response) => response.data)
        .catch((error) => {
          throw Error(error);
        });
    },
    {
      shouldRetryOnError: false,
      revalidateOnFocus: false,
      ...config,
    },
  );
}
